// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2wk0F","error":"Textarea_error__1TSir","readonly":"Textarea_readonly__3xxCX","disabled":"Textarea_disabled__3ylmH"};